// Format date with time (includes both date and time)
export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  try {
    return new Date(date).toLocaleString();
  } catch {
    return 'N/A';
  }
};

// Format date only (without time)
export const formatDate = (date) => {
  if (!date) return 'N/A';
  try {
    return new Date(date).toLocaleDateString();
  } catch {
    return 'N/A';
  }
};

// Format time only (without date)
export const formatTime = (date) => {
  if (!date) return 'N/A';
  try {
    return new Date(date).toLocaleTimeString();
  } catch {
    return 'N/A';
  }
};